module.exports = __webpack_public_path__ + "static/img/goal-12.3f544e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/innovation/goal-12.png
// module id = 1CeE
// module chunks = 2